/**
 * The frame around every auth page: no bottom navigation, because there is nothing to navigate
 * to yet, and a single centred column that works at phone width first.
 */

import { Outlet } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import type { ReactNode } from "react";

export function AuthLayout() {
  const { t } = useTranslation();
  return (
    <div className="flex min-h-full flex-col justify-center px-4 py-10">
      <div className="mx-auto w-full max-w-sm">
        <h1 className="text-brand-700 mb-6 text-center text-2xl font-semibold">{t("app.name")}</h1>
        <Outlet />
      </div>
    </div>
  );
}

/** A card with a heading and optional supporting line, shared by all the auth pages. */
export function AuthCard({
  title,
  description,
  children,
}: {
  title: ReactNode;
  description?: ReactNode;
  children: ReactNode;
}) {
  return (
    <section className="space-y-5 rounded-xl border border-stone-200 bg-white p-5 shadow-sm">
      <header className="space-y-1">
        <h2 className="text-lg font-semibold text-stone-900">{title}</h2>
        {description && <p className="text-sm text-stone-600">{description}</p>}
      </header>
      {children}
    </section>
  );
}
